import React, { useEffect, useState } from 'react';

import { Accordion, AccordionDetails, AccordionSummary, Grid, MenuItem, Select, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './ibp-obs.scss';

import { ibpMonitorMetrics } from '../../service/service';
import { ReactComponent as FilterIcon } from '../../assets/ml_summary_filter.svg';

import EyeIcon from '../../assets/lucide_info.svg';

import SyncIcon from '../../assets/uil_process1.svg'
import SyncActiveIcon from '../../assets/uil_process_selected.svg'
import IBPExecutedJobs from './ibp-jobs';

import Loader from '../Loader/loader';
import { useTheme } from "@mui/material/styles";

interface MetricDetails {
	totalGDOs: number;
	completedGDOs: number;
	totalJobs: number;
	successJobs: number;
	failedJobs: number;
	atRiskJobs: number;
}

export default function IbpMonitor() {
	const theme = useTheme();
	const colors = theme.palette;
    const [metricDetails, setMetricDetails] = useState<MetricDetails | null>(null);

	const [businessProcessList, setBusinessProcessList] = useState<any[]>([]);

	const [loading, setLoading] = useState(false);

	const [expanded, setExpanded] = React.useState<string | false>(false);
	const [expandedChild, setExpandedChild] = React.useState<string | false>(false);
	const [marketName, setMarketName] = useState<string>('FRANCE')

	const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		console.log(panel)
      setExpanded(isExpanded ? panel : false);
    };

	const handleChangeChild =
    (panel: string) => (event: React.SyntheticEvent, isExpandedChild: boolean) => {
		console.log(panel)
		setExpandedChild(isExpandedChild ? panel : false);
    };

    async function businessProcessListingFunc() {
		try {
			setLoading(true);
			const res = await ibpMonitorMetrics(marketName);
			if (res.success) {
				setMetricDetails(res.data.overall);
				console.log(res.data.overall, 'monitorData');
				const bpLists = res.data.businessProcesses.filter((bpData: any, index: number) => {
					bpData['id'] = index;
					return bpData
				});
				console.log(bpLists)
				setBusinessProcessList(bpLists);
			}			
		} catch(error: unknown) {
			console.error(error instanceof Error ? error.message : 'Something went wrong'); // Set error state when API call fails
		} finally {
			setLoading(false);
		};
    }
	
	useEffect(() => {
		if (!loading)
		businessProcessListingFunc();
	}, [marketName])

	return (
		<div className="page-table jobs-tabledata page-table-ibp-monitor">
            <div className="ibp-filter-wrapper">
                <div className="IBP-filter-text" style={{marginRight: 32}}>
                    <Select sx={{'& .MuiSelect-select': {
								display: 'flex',
								alignItems: 'center',
								color: colors.textLight.main,
								p: "3px 14px"
								},
							}} size="medium"
                        value={marketName}
                        onChange={(e: any) => {
                            setMarketName(e.target.value)
                        }}
                    >
                        <MenuItem value={'PBNA'}>IBP - PBNA</MenuItem>
                        <MenuItem value={'FRANCE'}>IBP - France</MenuItem>
                    </Select>
                </div> 
                <FilterIcon className="sector-filter1" />
            </div>

			<div className="dashboard-panel ibp-dashboard-wrapper">
				<Grid container spacing={0} className="headerIPB">
					<Grid item xs={6} className="headerIPB-title no-ml bgcolor-grey ">
						<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>Total GDO's </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of GDOs being Observed by PepWise' alt={`View Count of GDOs being Observed by PepWise`} /></span></div>
						{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.totalGDOs}</Typography></div>}
					</Grid>
					<Grid item xs={6} className="headerIPB-title subheaderIPB-title no-ml">
						<Grid container spacing={1} className="headerIPB">
							<Grid item xs={6} className="monitor-title bgcolor-green bdr-green">
						<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>Completed GDO's </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of GDOs whose jobs have completed successfully' alt={`View Count of GDOs whose jobs have completed successfully`}/></span></div>
						{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.completedGDOs}</Typography></div>}
							</Grid>
							<Grid item xs={6} className="monitor-title bgcolor-blue bdr-blue">
								<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>In Progress GDO's </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of GDOs whose jobs are currently running' alt={`View Count of GDOs whose jobs are currently running`}/></span></div>
								{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.totalGDOs - metricDetails.completedGDOs}</Typography></div>}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid container spacing={0} className="headerIPB">
					<Grid item xs={6} className="headerIPB-title no-ml bgcolor-grey">
						<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>Total Jobs </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of Total jobs being observed by PepWise' alt={`View Count of Total jobs being observed by PepWise`} /></span></div>
						{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.totalJobs}</Typography></div>}
					</Grid>
					<Grid item xs={6} className="headerIPB-title subheaderIPB-title no-ml">
						<Grid container spacing={1} className="headerIPB">
							<Grid item xs={4} className="monitor-title bgcolor-green">
								<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>Successful Jobs </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of jobs that have successful executions' alt={`View Count of jobs that have successful executions`} /></span></div>
								{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.successJobs}</Typography></div>}
							</Grid>
							<Grid item xs={4} className="monitor-title bgcolor-red bdr-red">
								<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>Failed Jobs </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of jobs that have failed executions' alt={`View Count of jobs that have failed executions`} /></span></div>
								{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.failedJobs}</Typography></div>}
							</Grid>
							<Grid item xs={4} className="monitor-title bgcolor-maroon bdr-yellow">
								<div className="monitor-head"><Typography variant="widgetTitle" component="span" sx={{ display: 'inline' }}>At Risk Jobs </Typography><span><img src={EyeIcon} className='eye-icon-styles' title='Count of jobs that ran for more that 90% of their expected run time' alt={`View Count of jobs that ran for more that 90% of their expected run time`} /></span></div>
								{metricDetails && <div className="subheader"><Typography variant="widgetValue" component="span" sx={{ display: 'inline' }}>{metricDetails.atRiskJobs}</Typography></div>}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</div>

			{ loading ? (
				<Loader />
			) : (
			<div className="business-process-accordion">
				<div style={{display:'flex', justifyContent: 'space-between', marginRight: 12}}>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">Business Processes</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">Total GDOs</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">Completed GDOs</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">In Progress GDOs</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">Total Jobs</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">Success Jobs</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">Failed Jobs</Typography>
					<Typography variant='bodyText' sx={{color : `${colors.textLight.main}`, display: 'inline' }} component="span">At Risk Jobs</Typography>
				</div>
				{ businessProcessList?.map((bpList: any, idx: number) => (
				<Accordion key={bpList.businessProcess} className="w-full" expanded={expanded === 'panel-'+idx} onChange={handleChange('panel-'+idx)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon className="according-expand-icon" />}
						aria-controls={`panel-`+idx+'-content'}
						id={`panel-`+idx+'-header'}
						>
						<div className="business-process--list"  style={{display:'flex', justifyContent: 'space-between', marginRight: 8}}>
							<div className="bp--name"> 
							{ expanded === 'panel-'+idx ? <div className='sync-wrap'><img src={SyncActiveIcon} alt="" /></div> : <div className='sync-wrap'><img src={SyncIcon} alt="" /></div> }
							<div className="business-process-wrap">
							{bpList.businessProcess}
							</div></div>
							<div className='count-badge-wrap total-gdos'><span className="count-badge total-gdos">{bpList.totalGDOs}</span></div>
							<div className='count-badge-wrap'><span className="count-badge completed-gdos">{bpList.completedGDOs}</span></div>
							<div className='count-badge-wrap'><span className="count-badge inprogress-gdos">{bpList.totalGDOs - bpList.completedGDOs}</span></div>
							<div className='count-badge-wrap'><span className="count-badge total-jobs">{bpList.totalJobs}</span></div>
							<div className='count-badge-wrap'><span className="count-badge success-jobs">{bpList.successJobs}</span></div>
							<div className='count-badge-wrap'><span className="count-badge failed-jobs">{bpList.failedJobs}</span></div>
							<div className='count-badge-wrap'><span className="count-badge at-risk-jobs">{bpList.atRiskJobs}</span></div>
						</div>
					</AccordionSummary>
					<AccordionDetails>
					{bpList.gdoDetails?.map((gdoList: any, index: number) => (
						<Accordion key={gdoList.gdo} className="w-full inner-accordion" expanded={expandedChild === 'panel2-'+index} onChange={handleChangeChild('panel2-'+index)}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon className="according-expand-icon" />}
								aria-controls={`panel2-`+index+'-content'}
								id={`panel2-`+index+'-header'}
								>
								<div className="business-process--list" style={{display:'flex', justifyContent: 'space-between'}}>
									<span className="bp--name">{gdoList.gdo} {gdoList.gdoDesc ? ' - '+gdoList.gdoDesc : ''}</span>
									<div className='count-badge-wrap total-gdos'><span className="count-badge total-gdos">-</span></div>
									<div className='count-badge-wrap'><span className="count-badge completed-gdos">{gdoList.completedGDOs}</span></div>
									<div className='count-badge-wrap'><span className="count-badge inprogress-gdos">{gdoList.completedGDOs? 0 : 1}</span></div>
									<div className='count-badge-wrap'><span className="count-badge total-jobs">{gdoList.totalJobs}</span></div>
									<div className='count-badge-wrap'><span className="count-badge success-jobs">{gdoList.successJobs}</span></div>
									<div className='count-badge-wrap'><span className="count-badge failed-jobs">{gdoList.failedJobs}</span></div>
									<div className='count-badge-wrap'><span className="count-badge at-risk-jobs">{gdoList.atRiskJobs}</span></div>
								</div>
							</AccordionSummary>
							<AccordionDetails style={{paddingRight: 0}}>
								{ expandedChild === 'panel2-'+index && <IBPExecutedJobs gdoName={gdoList.gdo} marketName={marketName}></IBPExecutedJobs> }
							</AccordionDetails>
						</Accordion>
					))}
					</AccordionDetails>
				</Accordion>
				))
				}
			</div>
			)}
		</div>
	);
}
